import { styled } from "@mui/material/styles";
import {
  Card,
  Typography,
  CardContent,
  CardActions,
  Divider,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  color: "white",
  backgroundColor: "#ee060b",
  borderRadius: "0.75rem !important",
  overflow: "inherit",
  height: "100%",
  boxShadow:
    "0rem 0.25rem 0.375rem -0.0625rem rgb(0 0 0 / 10%), 0rem 0.125rem 0.25rem -0.0625rem rgb(0 0 0 / 6%) !important",
}));
const IconWrapperStyle = styled("div")(({ theme }) => ({
  borderRadius: "50%",
  color: "black",
}));

export default function DashboardCard(props) {
  const theme = useTheme();
  return (
    <RootStyle>
      <Card>
        <Box sx={{ display: "flex" }}>
          <CardActions>
            <IconWrapperStyle>
              <Box
                borderRadius="xl"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="4rem"
                height="4rem"
                mt={-9}
              >
                {props.children}
              </Box>
            </IconWrapperStyle>
          </CardActions>
          <CardContent
            sx={{ textAlign: "right", width: "100%", height: "120px" }}
          >
            <Typography variant="p" sx={{ fontSize: "16px" }}>
              {props.tittle}
            </Typography>
            <Typography variant="h4">{props.total}</Typography>
          </CardContent>
        </Box>
        <Divider />
        {/*<Box p={2} sx={{textAlign: "left"}}>
        <Typography variant="p" ><LocalOfferIcon/> It is a long established fact</Typography>
  </Box>*/}
      </Card>
    </RootStyle>
  );
}
